<template>
    <div class="opened-messages-container shadow-sm">
        <div class="modal fade" id="editMessageModal" tabindex="-1" aria-labelledby="editMessageModal" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable">
                <div class="modal-content"  v-if="this.editedMessage != null">
                    <div class="modal-header">
                        <h5 class="modal-title" v-if="this.editedMessage != null && this.editedMessage.id != null">{{ $t("admin.opening_messages.edit_dialog.edit_title") }}</h5>
                        <h5 class="modal-title" v-if="this.editedMessage != null && this.editedMessage.id == null">{{ $t("admin.opening_messages.edit_dialog.new_title") }}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <h5>{{ $t("admin.opening_messages.edit_dialog.title_label") }}</h5>
                        <div class="mb-3">
                            <label for="title_english" class="form-label">{{ $t("admin.opening_messages.edit_dialog.english_label") }}</label>
                            <input type="text" class="form-control" id="title_english" v-model="editedMessage.title.en">
                        </div>
                        <div class="mb-3">
                            <label for="title_french" class="form-label">{{ $t("admin.opening_messages.edit_dialog.french_label") }}</label>
                            <input type="text" class="form-control" id="title_french" v-model="editedMessage.title.fr">
                        </div>

                        <h5>{{ $t("admin.opening_messages.edit_dialog.message_label") }}</h5>
                        <div class="mb-3">
                            <label for="message_english" class="form-label">{{ $t("admin.opening_messages.edit_dialog.english_label") }}</label>
                            <textarea class="form-control" id="message_english" v-model="editedMessage.message.en"></textarea>
                        </div>
                        <div class="mb-3">
                            <label for="message_french" class="form-label">{{ $t("admin.opening_messages.edit_dialog.french_label") }}</label>
                            <textarea type="text" class="form-control" id="message_french" v-model="editedMessage.message.fr"></textarea>
                        </div>

                        <h5>{{ $t("admin.opening_messages.edit_dialog.parameters_label") }}</h5>
                        <div class="mb-3">
                            <label for="frequency_select" class="form-label">{{ $t("admin.opening_messages.edit_dialog.frequency_label") }}</label>
                            <select type="text" class="form-control" id="frequency_select" v-model="editedMessage.frequency">
                                <option value="always">{{ $t("enums.frequency.always") }}</option>
                                <option value="once">{{ $t("enums.frequency.once") }}</option>
                                <option value="onceAMinute">{{ $t("enums.frequency.once_a_minute") }}</option>
                                <option value="onceAnHour">{{ $t("enums.frequency.once_an_hour") }}</option>
                                <option value="onceADay">{{ $t("enums.frequency.once_a_day") }}</option>
                                <option value="onceAWeek">{{ $t("enums.frequency.once_a_week") }}</option>
                                <option value="onceAMonth">{{ $t("enums.frequency.once_a_month") }}</option>
                            </select>
                        </div>

                        <div class="mb-3">
                            <label for="startDate" class="form-label">{{ $t("admin.opening_messages.edit_dialog.start_date_label") }}</label>
                            <DateSelector class="form-control start-date-input" id="startDate" v-model="editedMessageStartDate" mode="dateTime"></DateSelector>
                        </div>

                        <div class="mb-3">
                            <label for="endDate" class="form-label">{{ $t("admin.opening_messages.edit_dialog.end_date_label") }}</label>
                            <DateSelector class="form-control end-date-input" id="endDate" v-model="editedMessageEndDate" mode="dateTime"></DateSelector>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" v-on:click="handleCloseEditedMessageClicked()" >{{ $t("admin.opening_messages.edit_dialog.close_button") }}</button>
                        <button type="button" class="btn btn-primary" v-on:click="handleSaveAsDraftEditedMessageClicked()">{{ $t("admin.opening_messages.edit_dialog.save_as_draft_button") }}</button>
                        <button type="button" class="btn btn-primary" v-on:click="handleSaveAndPublishEditedMessageClicked()">{{ $t("admin.opening_messages.edit_dialog.save_and_publish_button") }}</button>
                    </div>
                </div>
            </div>
        </div>

        <YesNoAlert ref="confirmDeleteAlert" id="confirmDeleteAlert" v-bind:title="$t('admin.opening_messages.confirm_delete_title')" v-bind:message="$t('admin.opening_messages.confirm_delete_message')" v-on:yes="handleDeleteMessageConfirmed()" />

        <div class="toolbar">
            <button class="btn btn-primary btn-sm" v-on:click="handleNewMessageClicked()">{{ $t("admin.opening_messages.new_button") }}</button>
        </div>

        <ul class="messages-list">
            <li class="message-container header">
                <div class="message-title header">{{ $t("admin.opening_messages.message_header") }}</div>
                <div class="message-status header">{{ $t("admin.opening_messages.status_header") }}</div>
                <div class="message-actions header">{{ $t("admin.opening_messages.actions_header") }}</div>
                <div class="message-last-modified header">{{ $t("admin.opening_messages.last_updated_on_header") }}</div>
            </li>
        </ul>
        <div v-if="!messages || messages.length == 0" class="empty-list">{{ $t("admin.opening_messages.no_messages_label") }}</div>
        <div class="message-list-container">
            <ul class="messages-list scrolling-area">
                <li class="message-container" v-for="message of messages" v-bind:key="message.id">
                    <div class="message-status">
                        <span v-if="message.active" class="badge bg-success">{{ $t("admin.opening_messages.published_badge") }}</span>
                        <span v-if="!message.active" class="badge bg-info">{{ $t("admin.opening_messages.draft_badge") }}</span>
                    </div>
                    <div class="message-title">{{ messageTitle(message) }}</div>
                    <div class="message-content">{{ messageContent(message) }}</div>
                    <div class="message-parameters">{{ messageParameters(message) }}</div>
                    <div class="message-actions">
                        <button class="btn btn-primary btn-sm" v-on:click="handleEditMessageClicked(message)">{{ $t("admin.opening_messages.edit_button") }}</button>
                        <button v-if="message.active == false" class="btn btn-success btn-sm" v-on:click="handlePublishButtonClicked(message)">{{ $t("admin.opening_messages.publish_button") }}</button>
                        <button v-if="message.active == true" class="btn btn-info btn-sm" v-on:click="handleMarkAsDraftButtonClicked(message)">{{ $t("admin.opening_messages.mark_as_draft_button") }}</button>
                        <button class="btn btn-danger btn-sm" v-on:click="handleDeleteMessageClicked(message)">{{ $t("admin.opening_messages.delete_button") }}</button>
                    </div>
                    <div class="message-last-updated-on">{{ messageLastUpdatedOn(message) }}</div>
                    <hr />
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import DateSelector from "@/views/ui/dateselector/DateSelector.vue"
import MapOpeningMessageService from "@/service/MapOpeningMessageService.js";
import MapService from "@/service/MapService.js";
import MapOpeningMessage from "@/model/MapOpeningMessage.js";
import LangUtils from '@/utils/LangUtils';
import DateUtils from '@/utils/DateUtils';
import YesNoAlert from "@/views/ui/alert/YesNoAlert"
import * as moment from 'moment';

export default {
    name: "OpeningMessagesEditor",

    components: {
        DateSelector,
        YesNoAlert
    },

    data() {
        return {
            messages: null,
            editedMessage: null,
            editionModal: null,
            messageToDelete: null,
            mapOpeningMessageService: new MapOpeningMessageService(),
            mapService: new MapService()
        }
    },

    props: {
        publisherId: String,
        mapId: String
    },

    computed: {
        editedMessageStartDate: {
            get: function() {
                return this.editedMessage.startDate ? DateUtils.formatForDateTimeInput(new Date(this.editedMessage.startDate)) : null;
            },

            set: function(newValue) {
                if (this.editedMessage) {
                    this.editedMessage.startDate = newValue != null ? Date.parse(newValue) : null;
                }

                if (this.editedMessage.startDate == null) {
                    this.$forceUpdate();
                }
            }
        },

        editedMessageEndDate: {
            get: function() {
                return this.editedMessage.endDate ? DateUtils.formatForDateTimeInput(new Date(this.editedMessage.endDate)) : null;
            },

            set: function(newValue) {
                if (this.editedMessage) {
                    this.editedMessage.endDate = newValue != null ? Date.parse(newValue) : null;
                }

                if (this.editedMessage.endDate == null) {
                    this.$forceUpdate();
                }
            }
        }
    },

    watch: {
        editedMessage: function() {
            if (this.editedMessage != null) {
                this.editionModal.show();
            } else {
                this.editionModal.hide();
            }
        }
    },

    methods: {
        loadMessages() {
            this.mapOpeningMessageService.loadOpeningMessagesForMap(this.publisherId, this.mapId).then((openingMessages) => {
                this.messages = openingMessages;
            }).catch((error) => {
                console.log(error);
            });
        },

        saveMessage(message) {
            message.lastUpdate = new Date().getTime();

            this.mapService.loadMapForPublisher(this.publisherId, this.mapId).then((map) => {
                this.mapOpeningMessageService.saveMapOpeningMessage(this.$store.state.currentPublisher.id, message, map.legacyOpeningMessages).then(() => {
                    if (map.legacyOpeningMessages) {
                        this.mapService.touchMapBundlesForMap(this.publisherId, map);
                    }

                    this.editedMessage = null;
                    this.messageToDelete = null;
                    this.loadMessages();
                }).catch((error) => {
                    console.log(error);
                });
            }).catch((error) => {
                console.log(error);
            });
        },

        deleteMessage(message) {
            this.mapOpeningMessageService.deleteMapOpeningMessage(this.$store.state.currentPublisher.id, this.mapId, message.id).then(() => {
                this.mapService.loadMapForPublisher(this.publisherId, this.mapId).then((map) => {
                    if (map.legacyOpeningMessages) {
                        this.mapService.touchMapBundlesForMap(this.publisherId, map);
                    }
                    this.loadMessages();
                }).catch((error) => {
                    console.log(error);
                });
            }).catch((error) => {
                console.log(error);
            });
        },

        messageTitle(message) {
            return LangUtils.valueForLanguage(message.title, this.$i18n.locale);
        },

        messageContent(message) {
            return LangUtils.valueForLanguage(message.message, this.$i18n.locale);
        },

        messageParameters(message) {
            var parametersString = "";

            parametersString = this.$t("admin.opening_messages.edit_dialog.frequency_label") + ": ";
            switch(message.frequency) {
                case "always":
                    parametersString = parametersString + " " + this.$t("enums.frequency.always");
                    break;
                case "once":
                    parametersString = parametersString + " " + this.$t("enums.frequency.once");
                    break;
                case "onceAMinute":
                    parametersString = parametersString + " " + this.$t("enums.frequency.once_a_minute");
                    break;
                case "onceAnHour": 
                    parametersString = parametersString + " " + this.$t("enums.frequency.once_an_hour");
                    break;
                case "onceADay":
                    parametersString = parametersString + " " + this.$t("enums.frequency.once_a_day");
                    break;
                case "onceAWeek":
                    parametersString = parametersString + " " + this.$t("enums.frequency.once_a_week");
                    break;
                case "onceAMonth":
                    parametersString = parametersString + " " + this.$t("enums.frequency.once_a_month");
                    break;
                default:
                    parametersString = parametersString + " " + this.$t("enums.frequency.always");
                    break;
            }

            return parametersString;
        },

        messageLastUpdatedOn(message) {
            if (message.lastUpdate) {
                return moment(new Date(message.lastUpdate)).format("YYYY-MM-DD hh:mm");
            } else {
                return this.$t("admin.opening_messages.not_available_label");
            }
        },

        handleNewMessageClicked() {
            this.editedMessage = new MapOpeningMessage();
            this.editedMessage.active = true;
            this.editedMessage.mapIds = {};
            this.editedMessage.title = {
                en: null,
                fr: null
            }
            this.editedMessage.message = {
                en: null,
                fr: null
            }
            this.editedMessage.mapIds[this.mapId] = true;
            this.editedMessage.frequency = "always";
        },

        handleEditMessageClicked(message) {
            this.editedMessage = new MapOpeningMessage(JSON.parse(JSON.stringify(message)));
            if (!this.editedMessage.title) {
                this.editedMessage.title = {
                    en: null,
                    fr: null
                }
            }

            if (!this.editedMessage.message) {
                this.editedMessage.message = {
                    en: null,
                    fr: null
                }
            }

            if (!this.editedMessage.frequency) {
                this.editedMessage.frequency = "always";
            }
        },

        handlePublishButtonClicked(message) {
            message.active = true;
            this.saveMessage(message);
        },

        handleMarkAsDraftButtonClicked(message) {
            message.active = false;
            this.saveMessage(message);
        },

        handleDeleteMessageClicked(message) {
            this.messageToDelete = message;
            this.$refs.confirmDeleteAlert.show();
        },

        handleDeleteMessageConfirmed() {
            if (this.messageToDelete) {
                this.deleteMessage(this.messageToDelete);
            }
        },

        handleCloseEditedMessageClicked() {
            this.editedMessage = null;
        },

        handleSaveAsDraftEditedMessageClicked() {
            this.editedMessage.active = false;
            this.saveMessage(this.editedMessage);
        },

        handleSaveAndPublishEditedMessageClicked() {
            this.editedMessage.active = true;
            this.saveMessage(this.editedMessage);
        }
    },

    mounted() {
        this.editionModal = new this.bootstrap.Modal(document.getElementById('editMessageModal'));

        this.loadMessages();
    }
}
</script>

<style scoped>
.opened-messages-container {
    background-color: #ffffff;
    margin: 0 auto;
    padding: 24px;
    text-align: left;
    width: 100%;
    height: 100%;

    display: flex;
    flex-direction: column;
}

.message-list-container {
    width: 100%;
    height: 100%;
    overflow: scroll;
}

.messages-list {
    list-style-type: none;
    padding: 0px;
}

.empty-list {
    color: #777777;
    font-size: 36px;
    font-weight: bold;
    margin-top: 64px;
    text-align: center;
}

.header {
    border-bottom: 1px solid #999999;
    font-weight: bold;
    margin-top: 16px;
}

.scrolling-area {
    width: 100%;
    height: 100%;
}

.message-container {
    display: grid;
    grid-template-columns: auto 200px 400px 300px;
    grid-template-rows: auto auto auto auto;
    grid-template-areas: "title status actions lastupdatedon" "content . . ." "parameters parameters parameters parameters" "separator separator separator separator"
}

.message-badges {
    grid-area: badges;
}

.message-title {
    grid-area: title;
    font-weight: bold;
}

.message-content {
    grid-area: content;
    color: #555555;
    white-space: pre-line;
}

.message-status {
    grid-area: status;
}

.message-last-updated-on {
    grid-area: lastupdatedon;
}

.message-parameters {
    grid-area: parameters;
    color: #555555;
    font-size: 12px;
}

.message-actions {
    grid-area: actions;
}

.message-actions button {
    margin: 0px 4px;
}

.message-container hr {
    grid-area: separator;
}

.start-date-input {
    display: inline;
    margin-left: 8px;
    width: auto;
}

.end-date-input {
    display: inline;
    margin-left: 8px;
    width: auto;
}
</style>
